export enum CoordinationStatus {
  DMEOnly = 1,
  PTOnly = 2,
}

export const CoordinationStatusLabels: { [key: number]: string } = {
  [CoordinationStatus.DMEOnly]: 'DME Only',
  [CoordinationStatus.PTOnly]: 'PT Only',
}
